<template>
  <div class="contents-wrapper">
    <div class="contents-header">
      <div class="nav">
        <router-link to="/"><img :src="scroll_event_homeImage" /></router-link>
      </div>
    </div>
    <div class="contents-body">
      <div class="portfolio-top" />
      <div class="title">
        <h1 id="title">TeleRehab</h1>
        <p id="role">
          Product design<br />2020<br /><br />
          <a
            href="https://apps.apple.com/us/app/neofect-tele-rehab/id1509171956"
            target="_blank"
          >
            <img src="/images/appstore.png" alt="appstore" />
          </a>
        </p>
      </div>

      <div class="desc">
        <p id="desc">
          <b>Description</b>네오펙트의 B2B2C 서비스로 뇌졸증 환자를 대상으로
          하는 원격 재활 서비스이다. 치료사는 치료사 웹을 통해 환자들에게
          재활훈련을 추천해주고, 훈련데이터를 모니터링 한다. 또한 환자는
          텔레리햅 앱을 통해 집에서 스스로 재활훈련을 수행할 수 있다.
        </p>
        <p id="name">
          <b>Company:</b> Neofect<br />
          <b>Industry:</b> Healthcare<br />
          <b>Strategy:</b> Patrick, Donghoon Hong<br />
          <b>UX Design:</b> Hyunjeong Noh, Yuri Ahn<br />
          <b>UI/GUI Design:</b> Yuri Ahn<br />
          <b>Product devleopment:</b> Dev. team
        </p>
      </div>
      <div class="img-contents">
        <img src="/images/portfolios/telerehab/01.png" />
        <img src="/images/portfolios/telerehab/02.png" />
        <img src="/images/portfolios/telerehab/03.png" />
        <img src="/images/portfolios/telerehab/04.png" />
        <img src="/images/portfolios/telerehab/05.png" />
        <img src="/images/portfolios/telerehab/06.png" />
        <img src="/images/portfolios/telerehab/07.png" />
        <img src="/images/portfolios/telerehab/08.png" />
        <img src="/images/portfolios/telerehab/09.png" />
      </div>
    </div>
    <div class="move-btn">
      <span class="prev" @click="move('connect')">
        <img src="/images/chevron-left.svg" />Previous
      </span>
      <span class="next" @click="move('bium')">
        Next<img src="/images/chevron-right.svg" />
      </span>
    </div>
    <div class="contents-footer">
      <span class="name">
        <img src="/images/home_full_name.svg" />
      </span>
      <span class="copyright">
        <p>2021 ⓒ ahnyuri</p>
      </span>
    </div>
  </div>
</template>

<script>
import { ScrollEventMixin } from "@/mixins/ScrollEventMixin";
export default {
  name: "Detailtelerehab",
  mixins: [ScrollEventMixin],
  data() {
    return {};
  },
  methods: {
    move(url) {
      this.$router.push(`/detail/${url}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/HomeHeader.scss";
@import "@/views/HomeFooter.scss";
.contents-body {
  // display: flex;
  // outline: 1px red dashed;
  // height: 1500px;
}
.contents-wrapper {
  overflow-x: hidden;
}
.portfolio-top {
  width: 100%;
  height: 800px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  background-image: url("/images/portfolios/telerehab/top.png");
}

.title {
  float: left;
  margin-left: 10%;
  display: inline-block;
  margin-bottom: 0;
}

.title h1 {
  color: #303133;
  margin-top: 100px;
}
.title p {
  font-size: 13px;
  line-height: 20px;
  color: #606266;
  margin-top: -5px;
}
.desc {
  float: right;
  margin-right: 10%;
  margin-top: 85px;
  margin-bottom: 100px;
  width: 550px;
  font-size: 16px;
  line-height: 26px;
  color: #606266;
  display: inline-block;
}

.img-contents img {
  margin-top: -5px;
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}

.move-btn {
  cursor: pointer;
  width: 100%;
  display: inline-block;
}
.move-btn a {
  cursor: pointer;
}
.move-btn > .prev {
  color: #606266;
  margin-left: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: left;
}
.prev:hover {
  color: #303133;
}
.move-btn > .next {
  color: #606266;
  margin-right: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: right;
}
.next:hover {
  color: #303133;
}
@import "@/views/DetailZMedia.scss";
</style>
